import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

export type EmptyStateProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-4 py-10 text-center',
        className,
      )}
    >
      <div className="flex size-12 items-center justify-center rounded-full bg-bg text-text-muted">
        {icon ?? <Inbox className="size-6" aria-hidden />}
      </div>
      <div>
        <h3 className="m-0 text-h3 font-semibold text-text">{title}</h3>
        {description ? (
          <p className="mt-1 mb-0 max-w-md text-body text-text-secondary">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
